import React from "react";
import {
  applyAvatarImageFallback,
  baseURLImage,
  capitalizeFirstLetter,
  classNames,
  getNameProfile,
} from "../../../Utils/utils";
import PopoverStickOnHover from "../Popover/PopoverStick";
import PopoverContainer from "../Popover/PopoverContainer";
import useCareLabels from "hooks/useCareLabels";
import CareLabelSkeleton from "../CareLabelSkeleton/CareLabelSkeleton";

const AvatarGroup = (props) => {
  const { participantLabelPlural, isLoading: isCareLabelsLoading } = useCareLabels();
  const {
    arrayData,
    type,
    cssClass,
    maxLength = 0,
    isForRostering = false,
    popoverCss,
    styles = {},
    isGroupShift = [],
    noDataMsg = null,
    isNoRing = false,
    popoverZIndex,
  } = props;

  const handleImageError = (e, fname, lname) => {
    applyAvatarImageFallback(e, fname, lname);
  };

  const popOverContent = (data) => {
    return (
      <div
        className={classNames(
          "flex bg-white shadow-md rounded-md border border-1 border-[#F2F4F7] p-2 w-full",
          popoverCss
        )}
      >
        {data &&
          data.length > 0 &&
          data.map((item, index) => (
            <PopoverContainer
              key={item?.uuid || item?.id || index}
              cssClass={`${cssClass} text-sm bg-gradient ml-2 p-1 rounded-md text-white`}
              itemComponent={() => {}}
              zIndex={popoverZIndex}
              toolTip={item?.status && item?.status !== "active" ?  `${capitalizeFirstLetter(
                item?.first_name
              )} ${capitalizeFirstLetter(item?.last_name)} (Inactive)` : `${capitalizeFirstLetter(
                item?.first_name
              )} ${capitalizeFirstLetter(item?.last_name)}`}
            >
              <img
                onError={(e) =>
                  handleImageError(e, item?.first_name, item?.last_name)
                }
                className={`relative z-10 inline-block h-6 w-6 rounded-full ${isNoRing ? "" : "ring-2 ring-white"}`}
                src={
                  item?.photo || item?.profile_picture
                    ? baseURLImage(
                        item?.photo ? item?.photo : item?.profile_picture
                      )
                    : getNameProfile(item?.first_name, item?.last_name || " ")
                }
                alt='avatar'
              />
            </PopoverContainer>
          ))}
      </div>
    );
  };

  return (
    <div className='flex justify-start'>
      <div
        style={{ ...styles }}
        className={`mt-3 -space-x-1 relative z-0 overflow-hidden flex ${cssClass}`}
      >
        {arrayData &&
        arrayData.length > 0 &&
        maxLength !== 0 &&
        arrayData.length >= maxLength ? (
          <>
            {arrayData.slice(0, maxLength).map((item, index) => (
              <PopoverContainer
                key={item?.uuid || item?.id || index}
                cssClass={`${cssClass} text-sm bg-gradient ml-2 p-1 rounded-md text-white`}
                itemComponent={() => {}}
                zIndex={popoverZIndex}
                toolTip={item?.status && item?.status !== "active"? `${capitalizeFirstLetter(
                  item?.first_name
                )} ${capitalizeFirstLetter(item?.last_name)} (Inactive)` :`${capitalizeFirstLetter(
                  item?.first_name
                )} ${capitalizeFirstLetter(item?.last_name)}`}
              >
                <img
                  onError={(e) =>
                    handleImageError(e, item?.first_name, item?.last_name)
                  }
                  className={`relative z-10 inline-block ${
                    isForRostering ? "w-12 h-12" : "h-6 w-6"
                  } rounded-full ${isNoRing ? "" : "ring-2 ring-white"}`}
                  src={
                    item?.photo || item?.profile_picture
                      ? baseURLImage(
                          item?.photo ? item?.photo : item?.profile_picture
                        )
                      : getNameProfile(item?.first_name, item?.last_name || " ")
                  }
                  alt='avatar'
                />
              </PopoverContainer>
            ))}
            {arrayData && arrayData.length > maxLength && (
              <PopoverStickOnHover
                zIndex={popoverZIndex}
                item={popOverContent(
                  arrayData.slice(maxLength, arrayData.length)
                )}
              >
                <img
                  title={`${arrayData.length - maxLength}   ${
                    type
                      ? type === "worker"
                        ? "Workers"
                        : "Support Coordinators"
                      : ""
                  }`}
                  className={`relative z-10 inline-block h-3 w-3 rounded-full cursor-pointer ${isNoRing ? "" : "ring-2 ring-white"}`}
                  src={getNameProfile(`${arrayData.length - maxLength}`, "+")}
                  alt='avatar'
                />
              </PopoverStickOnHover>
            )}
          </>
        ) : arrayData && arrayData?.length > 0 ? (
          arrayData?.map((item, index) => (
            <React.Fragment key={item?.uuid || item?.id || index}>
           <PopoverContainer
                cssClass={`${cssClass} text-sm bg-gradient ml-2 p-1 rounded-md text-white`}
                itemComponent={() => {}}
                zIndex={popoverZIndex}
                toolTip={item?.status && item?.status !== "active"? `${capitalizeFirstLetter(
                  item?.first_name
                )} ${capitalizeFirstLetter(item?.last_name)} (Inactive)` :`${capitalizeFirstLetter(
                  item?.first_name
                )} ${capitalizeFirstLetter(item?.last_name)}`}
              >
                <img
                  onError={(e) =>
                    handleImageError(e, item?.first_name, item?.last_name)
                  }
                  className={`relative z-10 inline-block ${
                    isForRostering ? "w-12 h-12" : "h-6 w-6"
                  } rounded-full ${isNoRing ? "" : "ring-2 ring-white"}`}
                  src={
                    item?.photo || item?.profile_picture
                      ? baseURLImage(
                          item?.photo ? item?.photo : item?.profile_picture
                        )
                      : getNameProfile(item?.first_name, item?.last_name || " ")
                  }
                  alt='avatar'
                />
              </PopoverContainer>
              {/* <PopoverContainer
                cssClass={`${cssClass} text-sm bg-gradient ml-2 p-1 rounded-md text-white`}
                itemComponent={() => {}}
                toolTip={`${capitalizeFirstLetter(
                  item?.first_name
                )} ${capitalizeFirstLetter(item?.last_name)}`}
              >
                <img
                  onError={(e) =>
                    handleImageError(e, item?.first_name, item?.last_name)
                  }
                  key={index}
                  className={`relative z-10 inline-block ${
                    isForRostering ? "w-11 h-11" : "h-6 w-6"
                  } rounded-full ${isNoRing ? "" : "ring-2 ring-white"}`}
                  src={
                    item?.photo || item?.profile_picture
                      ? baseURLImage(
                          item?.photo ? item?.photo : item?.profile_picture
                        )
                      : getNameProfile(item?.first_name, item?.last_name || " ")
                  }
                  alt='avatar'
                />
              </PopoverContainer> */}
            </React.Fragment>
          ))
        ) : noDataMsg !== null ? (
          noDataMsg
        ) : type === "Participant" && isCareLabelsLoading ? (
          <>
            No <CareLabelSkeleton width="w-20" height="h-3.5" className="bg-gray-300 align-middle" /> Assigned
          </>
        ) : (
          `No ${
            type === "worker"
              ? "Workers"
              : type === "Participant"
              ? participantLabelPlural.toLowerCase()
              : "Support Coordinators"
          } Assigned`
        )}
      </div>
    </div>
  );
};

export default AvatarGroup;
